"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var service_1 = require("../api/service");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var DePermissionGuard = /** @class */ (function () {
    function DePermissionGuard(_dePermissionService, _router) {
        this._dePermissionService = _dePermissionService;
        this._router = _router;
    }
    /**
     * DE Permission Guard for checking DE permission and navigating to error page if has no given permission
     * depending on category Permission Type and module's System Name
     * 1. ADD
     * 2. EDIT
     * 3. VIEW
     * 4. DELETE
     *
     * @param {ActivatedRouteSnapshot} route
     * @returns {Observable<boolean>}
     */
    DePermissionGuard.prototype.canActivate = function (route) {
        var _this = this;
        var systemName = route.data.systemName;
        var categoryPermissionType = route.data.categoryPermissionType;
        var permissionType = route.data.permissionType;
        var categoryPermissionName = route.data.categoryPermissionName;
        var permissionErrorPage = route.data.permissionErrorPage;
        var queryParams = route.data.queryParams;
        var entityInstanceId = +route.params['instanceId'];
        if (entityInstanceId) {
            return this._dePermissionService
                .getCategoryDePermissionsByInstance(systemName, entityInstanceId)
                .pipe(operators_1.map(function (dePermission) {
                var permission = _this.convertPermission(categoryPermissionType, permissionType);
                var hasPermission = _this.hasPermission(permission, dePermission);
                if (!hasPermission) {
                    if (!categoryPermissionName) {
                        categoryPermissionName = route.url[0].path;
                    }
                    if (!queryParams) {
                        _this._router.navigateByUrl(permissionErrorPage + "/" + categoryPermissionName);
                    }
                    else {
                        _this._router.navigate([
                            permissionErrorPage + "/" + categoryPermissionName,
                        ], { queryParams: queryParams });
                    }
                }
                return hasPermission;
            }));
        }
        return this._dePermissionService
            .hasCreatePermissionByCategory(systemName)
            .pipe(operators_1.map(function (hasPermission) {
            if (!hasPermission) {
                if (!categoryPermissionName) {
                    categoryPermissionName = route.url[0].path;
                }
                if (!queryParams) {
                    _this._router.navigateByUrl(permissionErrorPage + "/" + categoryPermissionName);
                }
                else {
                    _this._router.navigate([
                        permissionErrorPage + "/" + categoryPermissionName,
                    ], { queryParams: queryParams });
                }
            }
            return hasPermission;
        }));
    };
    DePermissionGuard.prototype.convertPermission = function (categoryPermissionType, permissionType) {
        if (permissionType === undefined) {
            switch (categoryPermissionType) {
                case idm_um_permission_client_js_1.CategoryPermissionType.ADD: {
                    return idm_authorization_client_js_1.PermissionType.ADD;
                }
                case idm_um_permission_client_js_1.CategoryPermissionType.VIEW: {
                    return idm_authorization_client_js_1.PermissionType.VIEW;
                }
                case idm_um_permission_client_js_1.CategoryPermissionType.EDIT: {
                    return idm_authorization_client_js_1.PermissionType.EDIT;
                }
                case idm_um_permission_client_js_1.CategoryPermissionType.DELETE: {
                    return idm_authorization_client_js_1.PermissionType.DELETE;
                }
                default: {
                    throw new Error("Illegal permission type " + idm_um_permission_client_js_1.CategoryPermissionType[categoryPermissionType] + " was provided.");
                }
            }
        }
        else {
            return permissionType;
        }
    };
    DePermissionGuard.prototype.hasPermission = function (permissionType, dePermission) {
        switch (permissionType) {
            case idm_authorization_client_js_1.PermissionType.ADD: {
                return dePermission.canCreate;
            }
            case idm_authorization_client_js_1.PermissionType.VIEW: {
                return dePermission.canView;
            }
            case idm_authorization_client_js_1.PermissionType.EDIT: {
                return dePermission.canEdit;
            }
            case idm_authorization_client_js_1.PermissionType.DELETE: {
                return dePermission.canDelete;
            }
            default: {
                throw new Error("Illegal permission type " + idm_authorization_client_js_1.PermissionType[permissionType] + " was provided.");
            }
        }
    };
    DePermissionGuard = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [service_1.DePermissionService,
            router_1.Router])
    ], DePermissionGuard);
    return DePermissionGuard;
}());
exports.DePermissionGuard = DePermissionGuard;
//# sourceMappingURL=de-permission.guard.js.map